import { render, staticRenderFns } from "./prompts-page.vue?vue&type=template&id=8883b7e2&scoped=true"
import script from "./prompts-page.vue?vue&type=script&lang=js"
export * from "./prompts-page.vue?vue&type=script&lang=js"
import style0 from "./prompts-page.vue?vue&type=style&index=0&id=8883b7e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8883b7e2",
  null
  
)

export default component.exports